import Component from './component'
import connect from './connect'


export default connect(Component)
